import React, { Dispatch, useReducer } from "react";
import { MultiprofissionalStepForm } from "../config/MultiprofissionalStepForm";

import FormBase from "../forms/FormBase";
import Professional from "../models/Professional";
import FormFieldAttachmentBase, {
  FieldAttachment,
} from "../forms/FormFieldAttachmentBase";
import {
  Actions,
  IMultiprofissionalState,
  reducer,
  initialState,
  getStateFormPropertyByName,
} from "../context/reducers/MultiprofissionalReducer";
import ContextBase, { EAttachmentType } from "./ContextBase";

interface IMultiprofissionalContextProps {
  state: IMultiprofissionalState;
  dispatch: Dispatch<Actions>;
  nextStep: () => void;
  updateFile: (
    name: string,
    form: FormBase,
    fieldAttachment: FieldAttachment,
    formField: FormFieldAttachmentBase
  ) => void;
  deleteFile: (
    name: string,
    form: FormBase,
    fieldAttachment: FieldAttachment,
    formField: FormFieldAttachmentBase
  ) => void;
}

export const MultiprofissionalContext = React.createContext(
  {} as IMultiprofissionalContextProps
);

export function MultiprofissionalStoreProvider(props: any) {
  const [state, dispatch] = useReducer(reducer, initialState);

  //Método responsavel por avançar as etapas e criar um profissional quando não existir um
  const nextStep = async () => {
    try {

      //Pular a etapa de guia
      if (state.CurrentStep === 1) {
        ContextBase.goToNextStepWithLoading(dispatch, [], false);
        return;
      }

      //Apresenta o ícone de loading no botão de avançar
      ContextBase.setLoading(dispatch, true);

      //Cria ou busca no state um profissional
      let localProfessional = await ContextBase.createOrGetProfessionalDefault(dispatch, state) as Professional;

      //Realiza a chamada genérica das APIs que insere ou atualiza os dados do formulário
      await ContextBase.callInsertOrUpdateApiForms(MultiprofissionalStepForm, state, localProfessional, dispatch, (step, state) => { return getStateFormPropertyByName(step, state) });

    } catch (error) { }

  };

  //Método responsável por realizar o upload de arquivos
  const updateFile = async (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => {

    const formData = new FormData();
    formData.append("eAttachmentMultiprofissional", formField.TypeEnum.toString());
    formData.append("file", fieldAttachment.File);

    await ContextBase.updateloFile(dispatch, state.Professional, formData, fieldAttachment, name, form, EAttachmentType.Multiprofissional);
  };

  const deleteFile = async (name: string, form: FormBase, fieldAttachment: FieldAttachment) => {
    await ContextBase.deleteFile(dispatch, fieldAttachment, name, form);
  };

  const value = { state, dispatch, nextStep, updateFile, deleteFile };

  return (
    <MultiprofissionalContext.Provider value={value}>
      {props.children}
    </MultiprofissionalContext.Provider>
  );
}
